import Link from "next/link";
import clsx from "clsx";

type Variant = "primary" | "outlined" | "secondary";
interface ExternalLinkProps {
  fullSlug?: string;
  className?: string;
  name: string;
  style?: React.CSSProperties;
  variant?: Variant;
}

interface InternalLinkProps {
  href?: string;
  className?: string;
  name: string;
  style?: React.CSSProperties;
  variant?: Variant;
}

interface ButtonProps {
  disabled?: boolean;
  className?: string;
  name: string;
  style?: React.CSSProperties;
  variant?: Variant;
  onClick?: (e: any) => void;
}

type CtaProps = ExternalLinkProps & InternalLinkProps & ButtonProps;

const Cta = ({
  disabled,
  fullSlug,
  href,
  name,
  className,
  variant = "primary",
  style,
  onClick,
}: CtaProps) => {
  if (href) {
    return (
      <a
        className={clsx(
          "text-base cursor-pointer text-center",
          "rounded-md w-fit min-h-10 py-0 px-10 2xl:h-11.25",
          "flex items-center justify-center",
          "disabled:opacity-30 disabled:cursor-default",
          {
            "text-tm-c-light bg-tm-c-brand": variant === "primary",
            "text-tm-c-brand border-2 border-tm-c-brand bg-transparent":
              variant === "outlined",
            "text-tm-c-light bg-tm-c-gray-800": variant === "secondary",
          },
          className
        )}
        target="_blank"
        rel="noopener noreferrer"
        href={href}
        style={style}
      >
        <span>{name}</span>
      </a>
    );
  }

  if (onClick) {
    return (
      <button
        className={clsx(
          "text-[15px] 2xl:text-[17px] cursor-pointer text-center",
          "rounded-md w-fit min-h-10 py-0 px-10 2xl:h-11.25",
          "flex items-center justify-center",
          "disabled:opacity-30 disabled:cursor-default",
          {
            "text-tm-c-light bg-tm-c-brand": variant === "primary",
            "text-tm-c-brand border-2 border-tm-c-brand bg-transparent":
              variant === "outlined",
            "text-tm-c-light bg-tm-c-gray-800": variant === "secondary",
          },
          className
        )}
        style={style}
        disabled={disabled}
        onClick={onClick}
      >
        {name}
      </button>
    );
  }

  return (
    <Link
      href={`/${fullSlug}`}
      className={clsx(
        "text-[15px] 2xl:text-[17px] cursor-pointer text-center",
        "rounded-md w-fit min-h-10 py-0 px-10 2xl:h-11.25",
        "flex items-center justify-center",
        "disabled:opacity-30 disabled:cursor-default",
        {
          "text-tm-c-light bg-tm-c-brand": variant === "primary",
          "text-tm-c-brand border-2 border-tm-c-brand bg-transparent":
            variant === "outlined",
          "text-tm-c-light bg-tm-c-gray-800": variant === "secondary",
        },
        className
      )}
      style={style}
      onClick={onClick}
    >
      {name}
    </Link>
  );
};

export default Cta;
